export function isEmptyOrZero(value: number) {
    return value === undefined || value === null || value === 0
}
